<template>
<div>
  <custom-loader v-if="loadingData"/>
  <div v-else>
		<div v-if="newsAndAnnouncementsData">
			<news-and-announcement-permalink-featured-section :news-and-announcements-data="newsAndAnnouncementsData"/>
		</div>
		<div v-else>
			<div :style="elements.length > 0 ? getDynamicPageBg(elements[0]) : ''">
				<div class="container py-3">
					<div class="d-flex justify-content-end mb-3">
						<ol class="breadcrumb text-align-right">
							<li class="breadcrumb-item"><a href="/">Home</a></li>
							<li class="breadcrumb-item active">{{ loadingData ? '...' : menuName | capitalize }}</li>
						</ol>
					</div>
					<div class="d-flex justify-content-end align-items-center">
						<div v-if="canEditCms">
							<router-link :to="{ name: 'page-content-edit', params: {path: parameterize(menuName, '-'), id: menuId}}">
								<i class="fa fa-edit edit-icon" v-b-tooltip.hover title="Edit"></i>
							</router-link>
						</div>
						<div ref="parentQuickLinkContainer" class="ml-2">
							<custom-quick-link-section :quick-link-list="quickLinkList" />
						</div>
					</div>
				</div>
			</div>
			<div>
				<div class="elements-container row" v-if="elements.length > 0">
					<div
						v-for="element in elements"
						:key="element.id"
						class="col-12 element-container"
						:style="getDynamicPageBg(element)"
					>
						<div class="container">
							<custom-view-section :element="element" :quick-link-list="quickLinkList"/>
						</div>
					</div>
				</div>
				<div v-else class="regular-16 text-center text-muted py-5">
					There are no details available for this page. Please check back.
				</div>
			</div>
		</div>
  </div>
  <DoubleTheDonationFeatureSection v-if="$route.path === '/become-a-donor'" />
</div>
</template>

<script>
import { ParameterizeMixin } from "@/utils/ParameterizeMixin.js"
import CustomLoader from "@/components/CommonPages/CustomLoader.vue"
import mixin from "@/utils/mixin.js"
import { mapGetters } from "vuex"
import CustomViewSection from "@/components/Dynamic/CustomViewSection.vue"
import CustomQuickLinkSection from "@/components/QuickLink/CustomQuickLinkSection.vue"
import DoubleTheDonationFeatureSection from "@/components/Dashboard/DoubleTheDonationFeatureSection.vue"
import NewsAndAnnouncementPermalinkFeaturedSection from "@/components/NewsAndEvent/NewsAndAnnouncements/NewsAndAnnouncementPermalinkFeaturedSection.vue"

export default {
	name: "DynamicPage",
	metaInfo() {
		return {
			title: this.menuName ? this.menuName : "SLMath",
		}
	},
	components: {
		CustomLoader,
		CustomViewSection,
		CustomQuickLinkSection,
		DoubleTheDonationFeatureSection,
		NewsAndAnnouncementPermalinkFeaturedSection,
	},
	mixins: [ParameterizeMixin, mixin],
	data() {
		return {
			contentType: null,
			elements: [],
			loadingData: true,
			menuName: "",
			menuId: "",
			quickLinkList: [],
			newsAndAnnouncementsData: null,
		}
	},
	mounted() {
		this.getUrlMapperData()
	},
	computed: {
		...mapGetters(["canEditCms"]),
	},
	watch: {
		$route() {
			this.getUrlMapperData()
		},
	},
	updated() {
		MathJax.typeset()
	},
	methods: {
		loadScript(list) {
			list.forEach((data, index) => {
				const parser = new DOMParser()
				const htmlDoc = parser.parseFromString(data.value, "text/html")
				const scripts = htmlDoc.getElementsByTagName("script")
				for (let i = 0; i < scripts.length; i++) {
					if (scripts[i].src) {
						console.log(i, scripts[i].src)
						const s = document.createElement("script")
						// s.type = "text/javascript";
						// s.src = scripts[i].src;
						s.setAttribute("src", scripts[i].src)
						document.head.appendChild(s)
					} else {
						console.log(i, scripts[i].innerHTML)
						const script = document.createElement("script")
						script.setAttribute("innerHTML", scripts[i].innerHTML)
						script.text = scripts[i].innerHTML
						document.head.appendChild(script)
					}
				}
			})
		},
		async getScriptData(list) {
			try {
				if (list.length > 0) {
					await this.loadScript(list)
				}
			} catch (err) {
				console.log(err)
			}
		},
		async getDynamicData() {
			this.loadingData = true
			const res = await this.$http.get(`${process.env.VUE_APP_API_URL}/msri_menus/show_page_contents`, {
				params: {
					menu_path: this.$route.path,
				},
			})
			if (res !== undefined) {
				// if the page is present or not
				if (Object.keys(res.data).length) {
					this.getScriptData(res.data.results)
					this.menuId = res.data.id
					this.menuName = res.data.name
					this.elements = res.data.results
					this.quickLinkList = res.data.quick_link_list
					this.loadingData = false
				} else {
					// 404
					this.$router.push({ name: "not-found" })
				}
			}
		},
		async getUrlMapperData() {
			this.loadingData = true
			this.newsAndAnnouncementsData = null
			const currentUrl = window.location.pathname
			const response = await this.$http.get(`${process.env.VUE_APP_API_URL}/url_mappings/menu_url_map`, {
				params: {
					menu_path: currentUrl,
				},
			})
			if (response !== undefined) {
				if (response.data.id) {
					if (response.data.permalink_url) {
						// News And Announcements Data
						this.newsAndAnnouncementsData = response.data
						this.loadingData = false
					} else {
						// Url Mapper Data
						if (response.data.is_url_checked) {
							window.location.href = response.data.long_url
						} else {
							this.$router.push({ path: response.data.long_url })
						}
					}
				} else if (currentUrl.includes("summer_school_proposals")) {
					window.location.href = process.env.VUE_APP_LEGACY_MSRI_WEB_URL + currentUrl
				} else {
					this.getDynamicData()
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.row {
  display: block !important;
}
.elements-container {
  .element-container {
    //text-align: justify;
    word-wrap: break-word;
    display: flex;
    //align-items: center;
    //justify-content: center;
  }
}
</style>
